function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Book"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M4.165 8.645L181.589 4l2.576 117-177 8.5-3-120.854z",
  className: "boxFill"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1 7.736a2 2 0 011.948-2.052L181.825 1a2 2 0 012.052 1.947l3.101 118.416a2 2 0 01-1.907 2.05L6.285 131.639a1.998 1.998 0 01-2.09-1.945L1 7.736zM5.053 9.63l3.087 117.92 174.789-8.043-2.997-114.456L5.051 9.63z",
  className: "boxStroke",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  className: "bookStroke"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M100.095 38.033c-2.29 1.6-3.957 3.078-4.893 4.163l-.854 56.299c5.141-6.646 12.08-10.978 18.848-13.71 7.256-2.928 14.455-4.077 19.365-4.242l-1.019-38.944-.053-2-.248-9.49c-6.874-1.92-14.733-.291-21.63 2.662-3.634 1.556-6.913 3.444-9.516 5.262zm35.393 1.462l-.284-10.857c0-.04-.001-.078-.003-.117l-.014-.522-.086.002a1.994 1.994 0 00-1.233-1.256c-8.548-3.015-18.108-.958-25.832 2.35-3.896 1.668-7.415 3.691-10.232 5.66-1.836 1.282-3.431 2.581-4.647 3.783-1.064-.673-2.288-1.598-3.757-2.706v-.001l-.788-.594c-2.412-1.815-5.28-3.904-8.58-5.546-6.727-3.347-15.194-4.79-25.446.962-.572.32-.925.88-1.005 1.483l-.025.001.009.313v.003l.18 6.868-13.494 1.677a2 2 0 00-1.753 1.96l-.814 66.516a2 2 0 002.183 2.044l53.06-4.888 60.714-5.594 1.833-.168-.016-1.84-.496-58.007a2.002 2.002 0 00-2.052-1.982l-17.422.456zM41.71 107.332l44.949-4.141c-13.19-7.608-25.062-9.607-29.555-9.627l-1.94-.008-.05-1.94-1.264-48.278-11.373 1.414-.766 62.58zm49.494-65.3l-.89 58.674c-12.916-7.837-24.982-10.555-31.25-11.053L57.79 41.029l-.195-7.454c8.406-4.326 15.124-3.054 20.654-.302 2.945 1.464 5.563 3.359 7.957 5.16l.809.611.001.002c1.433 1.085 2.852 2.158 4.187 2.985zm60.238 55.19l-54.913 5.059c4.659-6.687 11.38-11.048 18.164-13.787 7.856-3.17 15.611-4.085 19.863-3.962l2.113.06-.056-2.112-1.021-38.987 15.387-.402.463 54.131z",
  className: "Union",
  clipRule: "evenodd"
})));

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 132,
    fill: "none",
    viewBox: "0 0 188 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.26cd3e3f.svg";
export { ForwardRef as ReactComponent };